/**
 * L'empilement : quand deux pièces sont la même chose.
 *
 * Enzo, en jouant : « il faut que les items soient stackables quand ce sont les
 * mêmes items. Parce que là j'ai plein de ferraille, de pierre de taille et
 * tout, et elles sont uniques, pas stackées. »
 *
 * ## L'empilement est un fait d'affichage, jamais de stockage
 *
 * Les sacs restent une ligne par pièce en base, et c'est délibéré : une ligne
 * porte son cran d'amélioration. Deux brigandines dont l'une a été montée d'un
 * cran **ne sont pas la même chose**, et un compteur unique par modèle les
 * aurait confondues. Fusionner en base aurait aussi cassé tout ce qui désigne
 * une pièce par son identifiant : un ordre de marché, un emplacement porté.
 *
 * D'où cette règle, écrite UNE fois et partagée : le serveur regroupe ce qu'il
 * propose à la vente, le client regroupe ce qu'il affiche dans les sacs, et les
 * deux comptent pareil. Deux règles de regroupement séparées finiraient par
 * annoncer une quantité et en vendre une autre.
 *
 * ## Ce qui fait un lot
 *
 * Le **modèle** et le **cran d'amélioration**, rien d'autre. Une pièce portée
 * ne rejoint aucun lot : elle est à sa place, on ne la vend pas par douze.
 */
/** Deux pièces d'un même lot portent cette clé. */
export function cleDeLot(modele, amelioration) {
    return `${modele}#${amelioration}`;
}
export function empiler(pieces, modele = (p) => p.code) {
    const parCle = new Map();
    const sortie = [];
    for (const p of pieces) {
        // Une pièce portée ne s'empile avec rien, pas même avec sa jumelle rangée.
        if (p.emplacement !== null) {
            sortie.push({ cle: `porte#${p.id}`, tete: p, pieces: [p], quantite: 1 });
            continue;
        }
        const cle = cleDeLot(modele(p), p.amelioration);
        const existant = parCle.get(cle);
        if (existant) {
            existant.pieces.push(p);
            existant.quantite++;
            continue;
        }
        const lot = { cle, tete: p, pieces: [p], quantite: 1 };
        parCle.set(cle, lot);
        sortie.push(lot);
    }
    return sortie;
}
